import { ZfFileItem } from '@zafire/react';
import type { FunctionComponent } from 'react';

interface IProps {
    fileName?: string;
    onFileDelete: () => void;
}

export const DocumentFileItemRow: FunctionComponent<IProps> = ({ fileName, onFileDelete }) => (
    <div
        style={{
            display: 'flex',
            alignItems: 'center',
            height: '36px',
            borderTop: '1px solid var(--border-color-default-normal)',
            padding: 'var(--padding-top-xxs) var(--padding-right-xl) 0 var(--padding-left-xl)',
        }}
    >
        <ZfFileItem style={{ flex: 1 }} name={fileName} downloadable={false} onFileDelete={onFileDelete} />
    </div>
);
